import React from "react";

const About = ({ darkTheme = true }) => {
  const bgColor = darkTheme ? "#0a0a0a" : "#f8f9fa";
  const textColor = darkTheme ? "#fff" : "#111";
  const subTextColor = darkTheme ? "#ccc" : "#666";
  const accentColor = "#ff0000";

  return (
    <section style={{
      paddingTop: "6rem", // Pushes content below fixed navbar
      paddingBottom: "4rem",
      backgroundColor: bgColor,
      color: textColor,
    }}>
      <div style={{
        maxWidth: "900px",
        margin: "0 auto",
        padding: "0 2rem",
        textAlign: "center",
      }}>
        {/* Section Label — matches Services/Artists style */}
        <span style={{
          color: accentColor,
          fontSize: "0.9rem",
          fontWeight: "600",
          letterSpacing: "2px",
          textTransform: "uppercase",
          display: "block",
          marginBottom: "1rem",
        }}>
          ABOUT US
        </span>

        <h1 style={{
          fontSize: "3rem",
          fontWeight: "700",
          marginBottom: "2rem",
          color: textColor,
          lineHeight: "1.2",
        }}>
        Faxon Entertainment
        </h1>

        <p style={{
          fontSize: "1.2rem",
          lineHeight: "1.7",
          color: subTextColor,
          marginBottom: "3rem",
        }}>
          Faxon Entertainment is a professional Artist, Athlete, and Model Management Agency.
          We specialize in brand management, ensuring each individual's talent is maximized
          for professional opportunities. Founded by Kagiso Mabule, we guide artists, models,
          athletes, and influencers to reach their full potential.
        </p>

        {/* Mission */}
        <div style={{ marginBottom: "3rem" }}>
          <h2 style={{
            fontSize: "2rem",
            fontWeight: "700",
            marginBottom: "1.5rem",
            color: textColor,
          }}>
            Our Mission
          </h2>
          <p style={{
            fontSize: "1.1rem",
            lineHeight: "1.7",
            color: subTextColor,
          }}>
            To empower African talent by providing professional management, branding, exposure,
            and global opportunities while nurturing creativity and growth.
          </p>
        </div>

        {/* Vision */}
        <div style={{ marginBottom: "3rem" }}>
          <h2 style={{
            fontSize: "2rem",
            fontWeight: "700",
            marginBottom: "1.5rem",
            color: textColor,
          }}>
            Our Vision
          </h2>
          <p style={{
            fontSize: "1.1rem",
            lineHeight: "1.7",
            color: subTextColor,
          }}>
            To be the leading talent management agency in Africa, recognized for elevating
            artists, athletes, and models to international success.
          </p>
        </div>

        {/* Core Values */}
        <div>
          <h2 style={{
            fontSize: "2rem",
            fontWeight: "700",
            marginBottom: "1.5rem",
            color: textColor,
          }}>
            Core Values
          </h2>
          <ul style={{
            textAlign: "left",
            margin: "0 auto",
            maxWidth: "600px",
            color: subTextColor,
            fontSize: "1.1rem",
            lineHeight: "1.7",
            paddingLeft: "1.5rem",
          }}>
            <li style={{ marginBottom: "0.8rem" }}>Integrity: We maintain transparency and honesty in all our dealings.</li>
            <li style={{ marginBottom: "0.8rem" }}>Professionalism: We uphold the highest industry standards.</li>
            <li style={{ marginBottom: "0.8rem" }}>Innovation: We constantly explore creative approaches to showcase talent.</li>
            <li style={{ marginBottom: "0.8rem" }}>Excellence: We strive for top-quality results in every project.</li>
            <li>Empowerment: We support and uplift our talent to achieve their dreams.</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default About;